import React from "react";

import useConditionEffect from "./useConditionEffect";
import usePrevious from "./usePrevious";

export default function useArrayEffect(
  callback: React.EffectCallback,
  array: any[],
  { ignoreOrder = false } = {}
) {
  const last = usePrevious(array);
  useConditionEffect(
    callback,
    !last ||
      array.length !== last.length ||
      array.some((item, i) =>
        ignoreOrder ? !last.includes(item) : item !== last[i]
      )
  );
}
